module.exports = __webpack_public_path__ + "img/23.669c0407.png";